import React from 'react'
import moment from 'moment'
import {
  DatePicker,
  Button,
  Table,
  Message,
  Select,
  Modal,
  Row,
  Col,
} from 'antd'
import {
  getStores,
  getStockJournal,
  getRecordDetail,
  getReduceStockDetail,
} from '../../../api/businessCommodity'
import MultiTable from './multiTable'
import { leadoutTable } from '../../../util/index'
import arrow from '../../../assert/images/double_arrow.png'

const { RangePicker } = DatePicker

export default class extends React.Component {
  state = {
    stockJournalType: '',
    storeList: [],
    storeId: '',
    startTimestamp: '',
    endTimestamp: '',
    startTime: '',
    endTime: '',
    mainList: [],
    fixedList: [],
    leadoutData: [],
    visible: false,
    recordDetail: {},
    detailType: '',
    detailTitle: '',
  }

  constructor(props) {
    super(props)
    // this.multiTableRef = React.createRef()
  }

  componentDidMount() {
    this.getStoreList()
    this.setState(
      {
        chosenDate:
          moment().startOf('month').format('YYYY-MM-DD') +
          ' ~ ' +
          moment().format('YYYY-MM-DD'),
        // startTimestamp: moment().startOf('month').format('X'),
        startTimestamp: moment().subtract(6, 'days').startOf('day').format('X'),
        endTimestamp: moment().endOf('day').format('X'),
        // startTime: moment().startOf('month').format('YYYY-MM-DD'),
        startTime: moment()
          .subtract(6, 'days')
          .startOf('day')
          .format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD'),
      },
      () => {
        this.getMainList()
      }
    )
  }

  getStoreList = async () => {
    const { data, status, detail } = await getStores()
    if (status == 1) {
      this.setState({ storeList: data })
    } else {
      Message.error(detail)
    }
  }

  dataChange = (date, dateString) => {
    if (date) {
      this.setState({
        chosenDate: dateString.join(' ~ '),
        startTimestamp: date[0].format('X'),
        endTimestamp: date[1].endOf('day').format('X'),
        startTime: dateString[0],
        endTime: dateString[1],
      })
    }
  }

  getMainList = async () => {
    const { startTimestamp, endTimestamp, storeId, stockJournalType } =
      this.state
    let params = {}
    if (startTimestamp && endTimestamp) {
      if (this.props.chosenItem) {
        params = {
          startTimestamp: startTimestamp,
          endTimestamp: endTimestamp,
          storeId: storeId,
          stockJournalType: stockJournalType,
          listingId: this.props.chosenItem.id,
        }
      } else {
        params = {
          startTimestamp: startTimestamp,
          endTimestamp: endTimestamp,
          storeId: storeId,
          stockJournalType: stockJournalType,
        }
      }
      const { data, status, detail } = await getStockJournal(params)
      if (status == 1) {
        data &&
          data.map((item, index) => {
            item.amount = item.amount / 100
            item.unitCost = item.unitCost / 100
          })
        this.setState({ leadoutData: data })

        let allDateObj = {}
        for (let i = 0; i < data.length; i++) {
          const item = data[i]
          if (!allDateObj[item.date]) {
            allDateObj[item.date] = [item]
          } else {
            allDateObj[item.date].push(item)
          }
        }
        const viewData = []
        for (const key in allDateObj) {
          let totalCount = 0
          for (let i = 0; i < allDateObj[key].length; i++) {
            const item = allDateObj[key][i]
            totalCount += item.quantity
          }
          viewData.push({
            date: key,
            totalQuantity: totalCount,
            stockJournals: allDateObj[key],
          })
        }
        // viewData &&
        //   viewData.map((item, index) => {
        //     item.stockJournals &&
        //       item.stockJournals.map(($item, $index) => {
        //         if ($item.type == 5) {
        //           this.up($index, item.stockJournals)
        //         }
        //       })
        //   })
        this.setState({ mainList: viewData.reverse() })
      } else {
        Message.error(detail)
      }
    } else {
      Message.error('请选择时间')
    }
  }

  onCancel = () => {
    this.setState({ visible: false })
  }

  showDetail = async (record, index) => {
    const { data, status, detail } = await getRecordDetail(record.journalId)
    if (status != 1) {
      Message.error(detail)
      return
    }
    if (data.journals.length > 0) {
      for (let i = 0; i < data.journals.length; i++) {
        if (data.journals[i].journal.type == 3) {
          data.income = data.journals[i]
        }
        if (data.journals[i].journal.type == 5) {
          data.outcome = data.journals[i]
        }
      }
    }
    let typeTitle = ''
    switch (record.type) {
      case 1:
        typeTitle = '进货详情'
        break
      case 2:
        typeTitle = '撤销订单详情'
        break
      case 3:
        typeTitle = '调货详情'
        break
      case 4:
        typeTitle = '销售详情'
        break
      case 5:
        typeTitle = '调货详情'
        break
      case 6:
        typeTitle = '销毁详情'
        break
      case 7:
        typeTitle = '退库详情'
        break
      case 8:
        typeTitle = '赠送详情'
        break
      case 9:
        typeTitle = '赠送详情'
        break

      default:
        break
    }
    this.setState({
      recordDetail: data,
      detailType: record.type,
      detailTitle: typeTitle,
      visible: true,
    })
  }

  showReduceDetail = async (record, index) => {
    const { data, status, detail } = await getReduceStockDetail({
      stockJournalId: record.journalId,
    })
    if (status != 1) {
      Message.error(detail)
      return
    }
    let typeTitle = ''
    switch (record.type) {
      case 1:
        typeTitle = '进货详情'
        break
      case 2:
        typeTitle = '撤销订单详情'
        break
      case 3:
        typeTitle = '调货详情'
        break
      case 4:
        typeTitle = '销售详情'
        break
      case 5:
        typeTitle = '调货详情'
        break
      case 6:
        typeTitle = '销毁详情'
        break
      case 7:
        typeTitle = '退库详情'
        break
      case 8:
        typeTitle = '赠送详情'
        break
      case 9:
        typeTitle = '赠送详情'
        break

      default:
        break
    }
    this.setState({
      recordDetail: data,
      detailType: record.type,
      detailTitle: typeTitle,
      visible: true,
    })
  }

  up = (index, array) => {
    if (index === 0) return array
    // 将上一个数组元素值替换为当前元素值，并将被替换的元素值赋值给当前元素
    array[index] = array.splice(index - 1, 1, array[index])[0]
    return array
  }

  render() {
    const mainColumns = [
      {
        title: '日期',
        dataIndex: 'date',
        key: 'date',
      },
      {
        title: '总数',
        dataIndex: 'totalQuantity',
        key: 'totalQuantity',
      },
    ]

    const batchColumns = [
      {
        title: 'id',
        dataIndex: 'listingId',
        key: 'listingId',
      },
      {
        title: '商品名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '仓库',
        dataIndex: 'storeName',
        key: 'storeName',
      },
      {
        title: '原库存',
        dataIndex: 'init',
        key: 'init',
      },
      {
        title: '类型',
        dataIndex: 'type',
        key: 'type',
        render: (text, record, index) => {
          if (text == 1) {
            return <div style={{ color: '#2D8CFF' }}>进货</div>
          }
          if (text == 2) {
            return <div style={{ color: '#FF0000' }}>撤销订单</div>
          }
          if (text == 3) {
            return <div style={{ color: '#44C80E ' }}>调入</div>
          }
          if (text == 4) {
            return <div style={{ color: '#D4540F' }}>销售</div>
          }
          if (text == 5) {
            return <div style={{ color: '#CE20C6' }}>调出</div>
          }
          if (text == 6) {
            return <div style={{ color: '#AAAAAA' }}>销毁</div>
          }
          if (text == 7) {
            return <div style={{ color: '#642D0D' }}>退库</div>
          }
          if (text == 8) {
            return <div style={{ color: '#FF0062' }}>套餐赠送</div>
          }
          if (text == 9) {
            return <div style={{ color: '#FF0062' }}>团购赠送</div>
          }
        },
      },
      {
        title: '数量',
        dataIndex: 'quantity',
        key: 'quantity',
      },
      {
        title: '现库存',
        dataIndex: 'balance',
        key: 'balance',
      },
      {
        title: '进货价（元）',
        dataIndex: 'unitCost',
        key: 'unitCost',
      },
      {
        title: '操作时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text, record, index) => {
          return moment(text).format('YYYY-MM-DD HH:mm')
        },
      },
      {
        title: '操作人',
        dataIndex: 'operatorName',
        key: 'operatorName',
      },
    ]

    const expandedRowRender = (record, index, indent, expanded) => {
      const batchColumns = [
        {
          title: 'id',
          dataIndex: 'listingId',
          key: 'listingId',
        },
        {
          title: '商品名称',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          key: 'quantity',
        },
        {
          title: '类型',
          dataIndex: 'type',
          key: 'type',
          render: (text, record, index) => {
            if (text == 1) {
              return <div style={{ color: '#2D8CFF' }}>进货</div>
            }
            if (text == 2) {
              return <div style={{ color: '#FF0000' }}>撤销订单</div>
            }
            if (text == 3) {
              return <div style={{ color: '#44C80E' }}>调入</div>
            }
            if (text == 4) {
              return <div style={{ color: '#D4540F' }}>销售</div>
            }
            if (text == 5) {
              return <div style={{ color: '#CE20C6' }}>调出</div>
            }
            if (text == 6) {
              return <div style={{ color: '#AAAAAA' }}>销毁</div>
            }
            if (text == 7) {
              return <div style={{ color: '#642D0D' }}>退库</div>
            }
            if (text == 8) {
              return <div style={{ color: '#FF0062' }}>套餐赠送</div>
            }
            if (text == 9) {
              return <div style={{ color: '#FF0062' }}>团购赠送</div>
            }
          },
        },
        {
          title: '操作时间',
          dataIndex: 'createTime',
          key: 'createTime',
          render: (text, record, index) => {
            return moment(text).format('YYYY-MM-DD HH:mm')
          },
        },
        {
          title: '操作人',
          dataIndex: 'operatorName',
          key: 'operatorName',
        },
      ]

      return (
        <MultiTable
          batchColumns={batchColumns}
          record={record}
          batchList={record.stockJournals}
          openMultiTable={this.openMultiTable}
          tableStatus="records"
          ref={this.multiTableRef}
          clickable={true}
          onRowclick={this.showDetail}
        ></MultiTable>
      )
    }

    const disabledDate = (current) => {
      if (current && this.state.firstSelectedTime) {
        if (
          current.isAfter(
            // moment(this.state.firstSelectedTime).add(1, 'months').add(1, 'days')
            moment(this.state.firstSelectedTime).add(6, 'days')
          )
        ) {
          return true
        }
      }
    }

    const onCalendarChange = (dates, dateStrings, info) => {
      if (dateStrings) {
        this.setState({ firstSelectedTime: dateStrings[0] })
      }
    }

    const onOpenChange = (open) => {
      if (!open) {
        this.setState({ firstSelectedTime: '' })
      }
    }

    const { recordDetail, detailType } = this.state

    return (
      <div>
        <div>
          <RangePicker
            className="mr-20"
            onChange={this.dataChange}
            disabledDate={disabledDate}
            onCalendarChange={onCalendarChange}
            onOpenChange={onOpenChange}
            // defaultValue={[moment().startOf('month'), moment()]}
            defaultValue={[
              moment().subtract(6, 'days').startOf('day'),
              moment(),
            ]}
          />

          <Select
            className="mr-20 title_slct"
            defaultValue=""
            value={this.state.stockJournalType}
            onChange={(value) => {
              this.setState({ stockJournalType: value })
            }}
          >
            <Select.Option value="">全部类型</Select.Option>
            <Select.Option value="1">进货</Select.Option>
            <Select.Option value="2">撤销订单</Select.Option>
            <Select.Option value="3">调入</Select.Option>
            <Select.Option value="4">销售</Select.Option>
            <Select.Option value="5">调出</Select.Option>
            <Select.Option value="6">销毁</Select.Option>
            <Select.Option value="7">退库</Select.Option>
            <Select.Option value="8">套餐赠送</Select.Option>
            <Select.Option value="9">团购赠送</Select.Option>
          </Select>

          <Select
            className="mr-20 title_slct"
            defaultValue=""
            value={this.state.storeId}
            onChange={(value) => {
              this.setState({ storeId: value })
            }}
          >
            <Select.Option value="">全部仓库</Select.Option>
            {this.state.storeList &&
              this.state.storeList.map((item, idx) => {
                return (
                  <Select.Option value={item.id} key={item.id}>
                    {item.name}
                  </Select.Option>
                )
              })}
          </Select>

          <Button type="primary" className="mr-20" onClick={this.getMainList}>
            显示
          </Button>

          <Button
            className="mr-20"
            href={
              this.state.leadoutData
                ? leadoutTable(this.state.leadoutData || [])
                : null
            }
            download={
              this.state.leadoutData
                ? this.state.chosenDate + '进出记录报表.csv'
                : null
            }
          >
            导出报表
          </Button>
        </div>
        <div>
          {/* <Table
            style={{ marginTop: '30px' }}
            bordered
            columns={mainColumns}
            expandable={{
              expandedRowRender,
              defaultExpandedRowKeys:
                this.state.mainList && this.state.mainList.length == 1
                  ? this.state.mainList[0].id
                  : null,
              // onExpand: (expanded, record) => {
              //   this.openMultiTable(expanded, record)
              // },
            }}
            dataSource={this.state.mainList}
            size="small"
            rowKey={(record, index) => index}
          /> */}

          <Table
            style={{ marginTop: '30px' }}
            bordered
            columns={batchColumns}
            dataSource={this.state.leadoutData}
            size="small"
            rowKey={(record, index) => index}
            onRow={(record, index) => {
              return {
                onClick: () => {
                  if (record.type != 7) {
                    this.showDetail(record, index)
                  } else {
                    this.showReduceDetail(record, index)
                  }
                },
              }
            }}
          />
        </div>

        <Modal
          title={this.state.detailTitle}
          visible={this.state.visible}
          onCancel={this.onCancel}
          onOk={this.onCancel}
          width="700px"
        >
          {/* 1.进货ok */}
          {detailType == 1 ? (
            <div>
              <Row className="mb-10 fw-b">
                <Col span={8}>批次信息</Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>批次号</Col>
                <Col span={16}>
                  {recordDetail.batch ? recordDetail.batch.batchNumber : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>库存数</Col>
                <Col span={16}>
                  {recordDetail.batch ? recordDetail.batch.quantity : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>入货时间</Col>
                <Col span={16}>
                  {recordDetail.batch
                    ? moment(recordDetail.batch.time).format('YYYY-MM-DD HH:mm')
                    : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>成本总价</Col>
                <Col span={16}>
                  {recordDetail.batch
                    ? (
                        (recordDetail.batch.unitCost *
                          recordDetail.batch.quantity) /
                        100
                      ).toFixed(2) + ' 元'
                    : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>操作人</Col>
                <Col span={16}>
                  {recordDetail ? recordDetail.operatorName : ''}
                </Col>
              </Row>
            </div>
          ) : null}

          {/* 2.撤销订单 */}
          {detailType == 2 ? (
            <div>
              <Row className="mb-10 fw-b">
                <Col span={8}>账单信息</Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>球台</Col>
                <Col span={16}>
                  {recordDetail.table ? recordDetail.table.name : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>商品名称</Col>
                <Col span={16}>
                  {recordDetail.listing ? recordDetail.listing.name : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>购买时间</Col>
                <Col span={16}>
                  {recordDetail.purchase
                    ? moment(recordDetail.purchase.createTime).format(
                        'YYYY-MM-DD HH:mm'
                      )
                    : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>撤销订单时间</Col>
                <Col span={16}>
                  {recordDetail.purchase
                    ? moment(recordDetail.purchase.updateTime).format(
                        'YYYY-MM-DD HH:mm'
                      )
                    : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>金额</Col>
                <Col span={16}>
                  ￥
                  {recordDetail.purchase
                    ? recordDetail.purchase.totalAmount / 100
                    : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>收银员</Col>
                <Col span={16}>
                  {recordDetail ? recordDetail.employeeName : ''}
                </Col>
              </Row>

              {!recordDetail.listing.isNonStandard ? (
                <div>
                  <Row className="mb-10 fw-b">
                    <Col span={8}>仓库信息</Col>
                  </Row>

                  <Row className="mb-20">
                    <Col span={8}>仓库名称</Col>
                    <Col span={16}>
                      {recordDetail.journals
                        ? recordDetail.journals[0].store.name
                        : ''}
                    </Col>
                  </Row>

                  <Row className="mb-20">
                    <Col span={8}>原仓库数</Col>
                    <Col span={16}>
                      {recordDetail.storeStockData
                        ? recordDetail.storeStockData[0].init
                        : ''}
                    </Col>
                  </Row>

                  <Row className="mb-20">
                    <Col span={8}>入库数量</Col>
                    <Col span={16}>
                      {recordDetail.journals
                        ? recordDetail.journals[1].journal.income
                        : ''}
                    </Col>
                  </Row>

                  <Row className="mb-20">
                    <Col span={8}>现库存数</Col>
                    <Col span={16}>
                      {recordDetail.storeStockData
                        ? recordDetail.storeStockData[0].quantity
                        : ''}
                    </Col>
                  </Row>
                </div>
              ) : null}
            </div>
          ) : null}

          {/* 3.调拨至此 / 5.从此调拨 */}
          {detailType == 3 || detailType == 5 ? (
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ minWidth: '20%' }}>
                  <Row className="mb-10 fw-b">
                    <Col span={24}>{recordDetail.outcome.store.name}</Col>
                  </Row>

                  <Row className="mb-20">
                    <Col span={16}>原库存数</Col>
                    <Col span={8} className="ta-r">
                      {recordDetail.outcome.journal.init}
                    </Col>
                  </Row>

                  <Row className="mb-20">
                    <Col span={16}>出库数量</Col>
                    <Col span={8} className="ta-r">
                      {recordDetail.outcome.journal.outcome}
                    </Col>
                  </Row>

                  <Row className="mb-20">
                    <Col span={16}>现库存数</Col>
                    <Col span={8} className="ta-r">
                      {recordDetail.outcome.journal.balance}
                    </Col>
                  </Row>
                </div>

                <div className="trans-store">
                  <img src={arrow} className="arrowImg" />
                </div>

                <div className="trans-product">
                  <span>{recordDetail.listing.name} </span>
                  <span className="fw-b">
                    * {recordDetail.outcome.journal.outcome}
                  </span>
                </div>

                <div className="trans-store">
                  <img src={arrow} className="arrowImg" />
                </div>

                <div style={{ minWidth: '20%' }}>
                  <Row className="mb-10 fw-b">
                    <Col span={24}>{recordDetail.income.store.name}</Col>
                  </Row>

                  <Row className="mb-20">
                    <Col span={16}>原库存数</Col>
                    <Col span={8} className="ta-r">
                      {recordDetail.income.journal.init}
                    </Col>
                  </Row>

                  <Row className="mb-20">
                    <Col span={16}>入库数量</Col>
                    <Col span={8} className="ta-r">
                      {recordDetail.income.journal.income}
                    </Col>
                  </Row>

                  <Row className="mb-20">
                    <Col span={16}>现库存数</Col>
                    <Col span={8} className="ta-r">
                      {recordDetail.income.journal.balance}
                    </Col>
                  </Row>
                </div>
              </div>

              <Row className="mb-20">
                <Col span={3}>操作人:</Col>
                <Col span={21}>
                  {recordDetail ? recordDetail.operatorName : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={3}>调货时间</Col>
                <Col span={21}>
                  {recordDetail.scheduled
                    ? moment(recordDetail.scheduled.createTime).format(
                        'YYYY-MM-DD HH:mm'
                      )
                    : ''}
                </Col>
              </Row>
            </div>
          ) : null}

          {/* 4.销售 */}
          {detailType == 4 ? (
            <div>
              <Row className="mb-10 fw-b">
                <Col span={8}>账单信息</Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>球台</Col>
                <Col span={16}>
                  {recordDetail.table ? recordDetail.table.name : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>商品名称</Col>
                <Col span={16}>
                  {recordDetail.listing ? recordDetail.listing.name : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>购买时间</Col>
                <Col span={16}>
                  {recordDetail.purchase
                    ? moment(recordDetail.purchase.createTime).format(
                        'YYYY-MM-DD HH:mm'
                      )
                    : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>结账时间</Col>
                <Col span={16}>
                  {recordDetail.bill
                    ? moment(recordDetail.bill.createTime).format(
                        'YYYY-MM-DD HH:mm'
                      )
                    : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>金额</Col>
                <Col span={16}>
                  ￥
                  {recordDetail.purchase
                    ? recordDetail.purchase.totalAmount / 100
                    : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>收银员</Col>
                <Col span={16}>
                  {recordDetail ? recordDetail.employeeName : ''}
                </Col>
              </Row>

              {!recordDetail.listing.isNonStandard ? (
                <div>
                  <Row className="mb-10 fw-b">
                    <Col span={8}>仓库信息</Col>
                  </Row>

                  <Row className="mb-20">
                    <Col span={8}>仓库名称</Col>
                    <Col span={16}>
                      {recordDetail.journals
                        ? recordDetail.journals[0].store.name
                        : ''}
                    </Col>
                  </Row>

                  <Row className="mb-20">
                    <Col span={8}>原仓库数</Col>
                    <Col span={16}>
                      {recordDetail.storeStockData
                        ? recordDetail.storeStockData[0].init
                        : ''}
                    </Col>
                  </Row>

                  <Row className="mb-20">
                    <Col span={8}>出库数量</Col>
                    <Col span={16}>
                      {recordDetail.journals
                        ? recordDetail.journals[0].journal.outcome
                        : ''}
                    </Col>
                  </Row>

                  <Row className="mb-20">
                    <Col span={8}>现库存数</Col>
                    <Col span={16}>
                      {recordDetail.storeStockData
                        ? recordDetail.storeStockData[0].quantity
                        : ''}
                    </Col>
                  </Row>
                </div>
              ) : null}
            </div>
          ) : null}

          {/* 6.销毁 */}
          {detailType == 6 ? (
            <div>
              <Row className="mb-10 fw-b">
                <Col span={8}>批次信息</Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>批次号</Col>
                <Col span={16}>
                  {recordDetail.batch ? recordDetail.batch.batchNumber : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>库存数</Col>
                <Col span={16}>
                  {recordDetail.batch ? recordDetail.batch.quantity : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>入货时间</Col>
                <Col span={16}>
                  {recordDetail.batch
                    ? moment(recordDetail.batch.time).format('YYYY-MM-DD HH:mm')
                    : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>销毁原因</Col>
                <Col span={16}>
                  {recordDetail.batch ? recordDetail.batch.description : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>操作人</Col>
                <Col span={16}>
                  {recordDetail ? recordDetail.operatorName : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>销毁时间</Col>
                <Col span={16}>
                  {recordDetail.listing
                    ? moment(recordDetail.listing.updateTime).format(
                        'YYYY-MM-DD HH:mm'
                      )
                    : ''}
                </Col>
              </Row>
            </div>
          ) : null}

          {/* 7.退库 */}
          {detailType == 7 ? (
            <div>
              <Row className="mb-10 fw-b">
                <Col span={8}>退库信息</Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>id</Col>
                <Col span={16}>{recordDetail.id}</Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>商品图片</Col>
                <Col span={16}>
                  <img
                    src={recordDetail.photo}
                    style={{
                      width: '80px',
                      height: '80px',
                      objectFit: 'cover',
                    }}
                  />
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>商品名称</Col>
                <Col span={16}>{recordDetail.commodityName}</Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>原库存</Col>
                <Col span={16}>{recordDetail.init}</Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>退库数量</Col>
                <Col span={16}>{recordDetail.reduceQuantity}</Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>现库存</Col>
                <Col span={16}>{recordDetail.balance}</Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>退库原因</Col>
                <Col span={16}>{recordDetail.note}</Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>操作人</Col>
                <Col span={16}>{recordDetail.operatorName}</Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>操作时间</Col>
                <Col span={16}>
                  {moment(recordDetail.createTime).format('YYYY-MM-DD HH:mm')}
                </Col>
              </Row>
            </div>
          ) : null}

          {/* 8 / 9.赠送 */}
          {detailType == 8 || detailType == 9 ? (
            <div>
              <Row className="mb-10 fw-b">
                <Col span={8}>账单信息</Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>球台</Col>
                <Col span={16}>
                  {recordDetail.table ? recordDetail.table.name : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>商品名称</Col>
                <Col span={16}>
                  {recordDetail.listing ? recordDetail.listing.name : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>赠送时间</Col>
                <Col span={16}>
                  {recordDetail.purchase
                    ? moment(recordDetail.purchase.createTime).format(
                        'YYYY-MM-DD HH:mm'
                      )
                    : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>金额</Col>
                <Col span={16}>
                  ￥
                  {recordDetail.purchase
                    ? recordDetail.purchase.totalAmount / 100
                    : ''}
                </Col>
              </Row>

              <Row className="mb-20">
                <Col span={8}>收银员</Col>
                <Col span={16}>
                  {recordDetail ? recordDetail.employeeName : ''}
                </Col>
              </Row>

              {!recordDetail.listing.isNonStandard ? (
                <div>
                  <Row className="mb-10 fw-b">
                    <Col span={8}>仓库信息</Col>
                  </Row>

                  <Row className="mb-20">
                    <Col span={8}>仓库名称</Col>
                    <Col span={16}>
                      {recordDetail.journals
                        ? recordDetail.journals[0].store.name
                        : ''}
                    </Col>
                  </Row>

                  <Row className="mb-20">
                    <Col span={8}>原仓库数</Col>
                    <Col span={16}>
                      {recordDetail.storeStockData
                        ? recordDetail.storeStockData[0].init
                        : ''}
                    </Col>
                  </Row>

                  <Row className="mb-20">
                    <Col span={8}>出库数量</Col>
                    <Col span={16}>
                      {recordDetail.journals
                        ? recordDetail.journals[0].journal.outcome
                        : ''}
                    </Col>
                  </Row>

                  <Row className="mb-20">
                    <Col span={8}>现库存数</Col>
                    <Col span={16}>
                      {recordDetail.storeStockData
                        ? recordDetail.storeStockData[0].quantity
                        : ''}
                    </Col>
                  </Row>
                </div>
              ) : null}
            </div>
          ) : null}
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/purchaseSalesInventory/components/storeRecord.js